"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.wizard.title': '入职向导',
    'onboarding.wizard.reset': '重置',
    'onboarding.wizard.loading': '加载中...',
    'onboarding.wizard.step.progress': '第 {current} 步，共 {total} 步',
    'onboarding.wizard.tab.profession': '选择职业',
    'onboarding.wizard.tab.steps': '完成步骤',
    'onboarding.wizard.tab.review': '审查',
    'onboarding.wizard.tab.completed': '已完成',
    'onboarding.wizard.profession.title': '选择您的职业',
    'onboarding.wizard.profession.subtitle': '选择最适合您角色的职业，以获得个性化的入职步骤。',
    'onboarding.wizard.profession.select': '选择',
    'onboarding.wizard.profession.selected': '已选择',
    'onboarding.wizard.profession.continue': '继续使用 {profession}',
    'onboarding.wizard.profession.loading': '加载职业中...',
    'onboarding.wizard.profession.empty': '没有可用的职业。请联系您的管理员。',
    'onboarding.wizard.navigation.previous': '上一步',
    'onboarding.wizard.navigation.next': '下一步',
    'onboarding.wizard.navigation.complete': '完成入职',
    'onboarding.wizard.navigation.backToSteps': '返回步骤',
    'onboarding.wizard.navigation.confirmComplete': '确认并完成',
    'onboarding.wizard.questions.placeholder': '请输入您的回答...',
    'onboarding.wizard.questions.required': '*',
    'onboarding.wizard.questions.selectOption': '请选择一个选项...',
    'onboarding.wizard.questions.empty': '此步骤没有可用的问题。',
    'onboarding.wizard.review.title': '审查您的入职',
    'onboarding.wizard.review.subtitle': '请在完成入职流程之前审查您的回答。',
    'onboarding.wizard.review.profession': '已选择的职业',
    'onboarding.wizard.review.steps': '已完成的步骤',
    'onboarding.wizard.review.notSelected': '未选择',
    'onboarding.wizard.completed.title': '入职完成！',
    'onboarding.wizard.completed.message': '恭喜！您已成功完成 {profession} 的入职流程。',
    'onboarding.wizard.completed.fallback': '您的职业',
    'onboarding.wizard.completed.startNew': '开始新入职',
};
